<template>
  <div>
    <template v-if="item.value instanceof Object && item.value.template">
      <div :class="item.class" :style="item.styles">
        <div :class="`custom-label ${item.labelClass}`" :style="labelStyles">
          <h6>{{ item.key }}</h6>
          <span v-if="item.showColon" class="custom-colon">:</span>
        </div>
        <div
          :class="`custom-value ${item.valueClass}`"
          :style="item.valueStyles"
        >
            <b-table-simple bordered>
                <b-thead>
                    <b-tr>
                        <b-th colspan="2"><span class="sr-only">Name and ID</span></b-th>
                        <b-th variant="" colspan="2" class="text-center">NOTA ARMADA</b-th>
                        <b-th variant="" colspan="2" class="text-center">ESTIMASI</b-th>
                        <b-th variant="" colspan="2" class="text-center">NOTA BONGKAR</b-th>
                        <b-th variant="" colspan="2" class="text-center">PERFORMANCE</b-th>
                        <b-th colspan="3"><span class="sr-only">Name and ID</span></b-th>
                    </b-tr>
                    <b-tr>
                        <b-th class="align-top">No</b-th>
                      <b-th class="align-top">{{ lodash.upperFirst($t('products.singular')) }}</b-th>
                        <b-th class="align-top">Size</b-th>
                        <b-th class="align-top">Biomassa</b-th>
                        <b-th class="align-top">Size</b-th>
                        <b-th class="align-top">Biomassa</b-th>
                        <b-th class="align-top">Size</b-th>
                        <b-th class="align-top">Biomassa</b-th>
                        <b-th class="align-top">Size</b-th>
                        <b-th class="align-top">Biomassa</b-th>
                        <b-th class="align-top">{{lodash.startCase($t('unloads.quality'))}}</b-th>
                        <b-th class="align-top">Harga Satuan Bongkar</b-th>
                        <b-th class="align-top">Jumlah Harga Bongkar</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="(value, index) in item.item" :key="index">
                        <b-td
                            v-if="value.rowspan"
                            :rowspan="value.rowspan"
                            class="align-middle"
                        >{{ value._index }}</b-td>
                        <b-td
                            v-if="value.rowspan"
                            :rowspan="value.rowspan"
                            class="align-middle"
                        >{{ (value.product || {}).name }}
                        </b-td>
                        <b-td
                            v-if="value.rowspan"
                            :rowspan="value.rowspan" 
                            class="text-center align-middle">{{ value.trip_item ? $numeral(value.initial_size).format("0,0.[00]"): '' }}</b-td>
                        <b-td
                            v-if="value.rowspan"
                            :rowspan="value.rowspan" 
                            class="text-center align-middle">{{ value.trip_item ? $numeral(value.initial_quantity).format("0,0.[00]")+' kg': '' }}</b-td>
                        <b-td
                            v-if="value.rowspan"
                            :rowspan="value.rowspan" 
                            class="text-center align-middle">{{ value.trip_item ? $numeral(value.estimated_size).format("0,0.[00]"): ''}}</b-td>
                        <b-td
                            v-if="value.rowspan"
                            :rowspan="value.rowspan" 
                            class="text-center align-middle">{{ value.trip_item ? $numeral(value.estimated_quantity).format("0,0.[00]")+' kg': '' }}</b-td>
                        <b-td class="text-center">{{ $numeral(value.size).format("0,0.[00]") }}</b-td>
                        <b-td class="text-center">{{ $numeral(value.quantity).format("0,0.[00]")+' kg' }}</b-td>
                        <b-td
                            :class="{
                                'bg-danger': value.size_performance < 5,
                                'bg-success': value.size_performance >= 5,
                                'text-center': true,
                                'align-middle': true,
                                'text-white': true,
                            }"
                        >{{ $numeral(value.size_performance).format("0,0.[00]")+'%' }}</b-td>
                        <b-td
                            v-if="value.rowspan"
                            :class="{
                                'bg-danger': value.quantity_performance < 5,
                                'bg-success': value.quantity_performance >= 5,
                                'text-center': true,
                                'align-middle': true,
                                'text-white': true,
                            }"
                            :rowspan="value.rowspan"
                        >{{ value.quantity_performance !== null ? $numeral(value.quantity_performance).format("0,0.[00]")+'%': '' }}</b-td>
                        <b-td>{{ $t(`qualities.${value.quality}`) }}</b-td>
                        <b-td>{{ $numeral(value.unit_price).format("$ 0,0.[00]") }}</b-td>
                        <b-td>{{ $numeral(value.total_price).format("$ 0,0.[00]") }}</b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  data() {
    return {
      labelStyles: {
        display: "flex",
        justifyContent: "space-between",
        ...this.item.labelStyles,
      },
    };
  },
};
</script>